// extracted by mini-css-extract-plugin
export var divider = "_yv-0";